import React, { Component } from 'react';
import { getTranslatedKey } from '../Utils/TranslateUtils';
import {
  SVGNewTab,
  SidebarContainer,
  SidebarWrapper,
  SidebarTable,
  SidebarRow,
  SidebarSubRow,
  SidebarSubTable,
  SeparatorRow,
  GencatLinks,
  Descripcio
} from './SidebarElements';
import { config } from '../../config/Config';
import { displayComponents, visorVariables } from './../Utils/VisorsUtils';

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleGuia = () => {
    this.props.toggleAjuda();
    this.props.toggleMenuLateral();
  };

  handlePantallaInfoAccess = () => {
    this.props.toggleInfoAccessibilitat();
    this.props.toggleMenuLateral(false);
  };

  handlePantallaInfoCookies = () => {
    this.props.toggleInfoCookies();
    this.props.toggleMenuLateral(false);
  };
  handleGuiaUs = () => {
    const newTab = window.open(visorVariables.urlManual, '_blank');
    newTab.focus();
  };
  handleFaqs = () => {
    const newTab = window.open(visorVariables.urlFaqs, '_blank');
    newTab.focus();
  };
  handleTutorial = () => {
    const newTab = window.open(visorVariables.urlTutorial, '_blank');
    newTab.focus();
  };

  render() {
    return (
      <>
        <SidebarContainer isOpen={this.props.isOpen} fontSizeEnabled={this.props.fontSizeEnabled} width={window.innerWidth * 0.75 + 'px'}>
          <SidebarWrapper>
            <SidebarTable>
              <SidebarRow>
                <SidebarSubTable>
                  {displayComponents.ajuda && (
                    <SidebarSubRow title={getTranslatedKey('help')}>
                      <GencatLinks onClick={this.handleGuia} aria-label={'Ajuda'}>
                        {getTranslatedKey('help')}
                      </GencatLinks>
                    </SidebarSubRow>
                  )}
                  {displayComponents.manual && (
                    <SidebarSubRow title={getTranslatedKey('guiaUs')}>
                      <GencatLinks onClick={() => this.handleGuiaUs()} aria-label={getTranslatedKey('aria_guiaUs')}>
                        {getTranslatedKey('guiaUs')}
                        <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                          <g>
                            <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                            <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                          </g>
                        </SVGNewTab>
                      </GencatLinks>
                    </SidebarSubRow>
                  )}
                  {displayComponents.tutorial && (
                    <SidebarSubRow title={getTranslatedKey('tutorial')}>
                      <GencatLinks onClick={() => this.handleTutorial()} aria-label={getTranslatedKey('tutorial')}>
                        {getTranslatedKey('tutorial')}
                        <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                          <g>
                            <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                            <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                          </g>
                        </SVGNewTab>
                      </GencatLinks>
                    </SidebarSubRow>
                  )}
                  {displayComponents.faqs && (
                    <SidebarSubRow title={getTranslatedKey('faqs')}>
                      <GencatLinks onClick={() => this.handleFaqs()} aria-label={getTranslatedKey('faqs')}>
                        {getTranslatedKey('faqs')}
                        <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                          <g>
                            <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                            <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                          </g>
                        </SVGNewTab>
                      </GencatLinks>
                    </SidebarSubRow>
                  )}
                  {displayComponents.contact && (
                    <SidebarSubRow title={getTranslatedKey('bustiaContacte')}>
                      <GencatLinks rel="noreferrer" target="_blank" href={visorVariables.correuSuggeriment}>
                        {getTranslatedKey('bustiaContacte')}
                        <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                          <g>
                            <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                            <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                          </g>
                        </SVGNewTab>
                      </GencatLinks>
                    </SidebarSubRow>
                  )}
                </SidebarSubTable>
              </SidebarRow>
              <SeparatorRow />
              <SidebarRow>
                <SidebarSubTable>
                  {displayComponents.infoA11y && (
                    <SidebarSubRow title={getTranslatedKey('accessibilitat')}>
                      <GencatLinks rel="noreferrer" onClick={this.handlePantallaInfoAccess}>
                        {getTranslatedKey('accessibilitat')}
                      </GencatLinks>
                    </SidebarSubRow>
                  )}
                  <SidebarSubRow title={getTranslatedKey('avisLegal')}>
                    <GencatLinks rel="noreferrer" target="_blank" href={config.avisLegalUrl}>
                      {getTranslatedKey('avisLegal')}
                      <SVGNewTab id="Layer_1" enable-background="new 0 0 20 20" viewBox="0 0 20 20" fill="white">
                        <g>
                          <path d="m14 0v2h2.6l-8.3 8.3 1.4 1.4 8.3-8.3v2.6h2v-6z" />
                          <path d="m16 18h-14v-14h9v-2h-11v18h18v-11h-2z" />
                        </g>
                      </SVGNewTab>
                    </GencatLinks>
                  </SidebarSubRow>
                </SidebarSubTable>
              </SidebarRow>
            </SidebarTable>
            <Descripcio fontSizeEnabled={this.props.fontSizeEnabled}>{visorVariables.descripcio}</Descripcio>
          </SidebarWrapper>
        </SidebarContainer>
      </>
    );
  }
}
